import React, { useState } from "react";
import "./Freight.css";
import IFTA from "../../Componenets/IFTA/IFTA";
import { useToast } from "../../Componenets/Toast/Toast";
import { IconAlerta, IconPacote } from "../../Shared/Icons/Icons";
import { apiFetch } from "../../Shared/Api/apiClient";

const Freight = () => {
  const toast = useToast();
  const [adicionandoProduto, setAdicionandoProduto] = useState(false);
  const [calculandoFrete, setCalculandoFrete] = useState(false);
  const [skuValue, setSkuValue] = useState("");
  const [quantity, setQuantity] = useState(1);
  const [error, setError] = useState("");
  const [listProducts, setListProducts] = useState([]);
  const [totalHeight, setTotalHeight] = useState(0);
  const [totalWidth, setTotalWidth] = useState(0);
  const [totalLength, setTotalLength] = useState(0);
  const [totalWeight, setTotalWeight] = useState(0);
  const [fromPostalCode, setFromPostalCode] = useState("83050-080");
  const [toPostalCode, setToPostalCode] = useState("");
  const [insuranceValue, setInsuranceValue] = useState("");
  const [freightResult, setFreightResult] = useState(null);

  const handleProduct = async () => {
    setError("");

    if (!skuValue.trim() || !quantity || quantity <= 0) {
      setError("Por favor, insira um sku válido e uma quantidade válida.");
      return;
    }

    setAdicionandoProduto(true);
    try {
      const searchResponse = await apiFetch(
        `/ERP/Products/Search?skuValue=${encodeURIComponent(
          skuValue
        )}`,
        { method: "GET", headers: { "Content-Type": "application/json" } }
      );

      if (!searchResponse.ok) {
        const errorData = await searchResponse.json();
        throw new Error(errorData.msg || "Erro ao buscar sku ");
      }

      const searchData = await searchResponse.json();
      if (!searchData.produtoId) {
        setError("Nenhum produto encontrado.");
        return;
      }

      const productResponse = await apiFetch(
        `/ERP/Products/Obter?id=${encodeURIComponent(
          searchData.produtoId
        )}`,
        { method: "GET", headers: { "Content-Type": "application/json" } }
      );

      if (!productResponse.ok) {
        const errorData = await productResponse.json();
        throw new Error(errorData.msg || "Erro ao obter detalhes do produto");
      }

      const productData = await productResponse.json();
      const {
        peso_liquido,
        comprimentoEmbalagem,
        alturaEmbalagem,
        larguraEmbalagem,
      } = productData.retorno.produto;

      setListProducts((prevProducts) => {
        const existingProductIndex = prevProducts.findIndex(
          (prod) => prod.skuValue === skuValue
        );

        if (existingProductIndex !== -1) {
          const updatedProducts = prevProducts.map((prod, index) =>
            index === existingProductIndex
              ? {
                  ...prod,
                  quantity: prod.quantity + Number(quantity),
                }
              : prod
          );

          updateTotals(updatedProducts);
          return updatedProducts;
        } else {
          const newProduct = {
            id: searchData.produtoId,
            skuValue: skuValue,
            weight: Number(peso_liquido),
            length: Number(comprimentoEmbalagem),
            height: Number(alturaEmbalagem),
            width: Number(larguraEmbalagem),
            insuranceValue: Number(insuranceValue) || 0,
            quantity: Number(quantity),
          };

          const updatedList = [...prevProducts, newProduct];
          updateTotals(updatedList);
          return updatedList;
        }
      });

      setSkuValue("");
      setInsuranceValue("");
      setQuantity(1);
    } catch (err) {
      setError(err.message);
    } finally {
      setAdicionandoProduto(false);
    }
  };

  const updateTotals = (productList) => {
    setTotalHeight(
      productList.reduce((sum, prod) => sum + prod.height, 0).toFixed(2)
    );
    setTotalWidth(
      productList.reduce((sum, prod) => sum + prod.width, 0).toFixed(2)
    );
    setTotalLength(
      productList.reduce((sum, prod) => sum + prod.length, 0).toFixed(2)
    );
    setTotalWeight(
      productList.reduce((sum, prod) => sum + prod.weight, 0).toFixed(2)
    );
  };

  const handleFreightCalculation = async () => {
    setError("");
    console.log("Altura total:" + totalHeight);
    console.log("Largura total:" + totalLength);
    console.log("Peso total:" + totalWeight);
    console.log("Comprimento total:" + totalWidth);

    if (
      !fromPostalCode.trim() ||
      !toPostalCode.trim() ||
      listProducts.length === 0
    ) {
      setError("Preencha os campos e adicione pelo menos um produto.");
      return;
    }

    setCalculandoFrete(true);
    try {
      const response = await apiFetch(
        `/ERP/Frete/Calculadora?fromPostalCode=${encodeURIComponent(
          fromPostalCode
        )}&toPostalCode=${encodeURIComponent(
          toPostalCode
        )}&products=${encodeURIComponent(JSON.stringify(listProducts))}`,
        { method: "GET", headers: { "Content-Type": "application/json" } }
      );

      console.log("Lista de produtos abaixo");
      console.log(listProducts);

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.msg || "Erro ao calcular o frete");
      }

      const data = await response.json();

      if (data && Array.isArray(data.data)) {
        const filteredData = data.data.filter(
          (service) => service.name === "PAC" || service.name === "SEDEX"
        );
        setFreightResult(filteredData);
      } else {
        throw new Error("Dados do frete não encontrados.");
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setCalculandoFrete(false);
    }
  };

  const handleClearData = () => {
    setSkuValue("");
    setQuantity(1);
    setError("");
    setListProducts([]);
    setTotalHeight(0);
    setTotalWidth(0);
    setTotalLength(0);
    setTotalWeight(0);
    setFromPostalCode("");
    setToPostalCode("");
    setInsuranceValue("");
    setFreightResult(null);
  };

  const handleClientMsg = () => {
    if (!freightResult || freightResult.length === 0) {
      setError("Nenhum resultado de frete disponível para copiar.");
      return;
    }

    let mensagem = "Valor do frete:\n";

    freightResult.forEach((option) => {
      const price = Number(option.price * 1.3);

      if (!isNaN(price)) {
        mensagem += `${option.name}: R$${price.toFixed(2)} - ${
          option.delivery_time
        } dias úteis\n`;
      } else {
        console.error(
          `Erro: option.price não é um número válido`,
          option.price
        );
      }
    });

    navigator.clipboard
      .writeText(mensagem)
      .then(() => toast.sucesso("Mensagem copiada para a área de transferência."))
      .catch(() => setError("Erro ao copiar mensagem."));
  };

  const temProdutos = listProducts.length > 0;

  return (
    <div className="page">
      <div className="page-header">
        <h1 className="page-title">Cotação de frete</h1>
        <p className="page-subtitle">
          Adicione os produtos pelo SKU e calcule o frete por PAC e SEDEX.
        </p>
      </div>

      <div className="freight-grid">
        <section className="card freight-card" aria-labelledby="frete-envio-titulo">
          <h2 id="frete-envio-titulo" className="card-title">
            Dados de envio
          </h2>
          <IFTA
            id="frete-cep-origem"
            text="CEP de origem"
            value={fromPostalCode}
            onChange={(e) => setFromPostalCode(e.target.value)}
            inputMode="numeric"
          />
          <IFTA
            id="frete-cep-destino"
            text="CEP de destino"
            value={toPostalCode}
            onChange={(e) => setToPostalCode(e.target.value)}
            mask="99999-999"
            inputMode="numeric"
          />

          <div className="freight-actions">
            <button
              type="button"
              className="btn btn-primary"
              onClick={handleFreightCalculation}
              disabled={calculandoFrete}
              aria-busy={calculandoFrete}
            >
              {calculandoFrete && <span className="spinner" aria-hidden="true" />}
              {calculandoFrete ? "Calculando…" : "Calcular frete"}
            </button>
            {temProdutos && (
              <>
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={handleClientMsg}
                >
                  Copiar mensagem
                </button>
                <button
                  type="button"
                  className="btn btn-ghost"
                  onClick={handleClearData}
                >
                  Limpar dados
                </button>
              </>
            )}
          </div>
        </section>

        <section className="card freight-card" aria-labelledby="frete-produtos-titulo">
          <h2 id="frete-produtos-titulo" className="card-title">
            Produtos
          </h2>
          <form
            className="freight-product-form"
            onSubmit={(e) => {
              e.preventDefault();
              handleProduct();
            }}
          >
            <IFTA
              id="frete-sku"
              text="SKU do produto"
              value={skuValue}
              onChange={(e) => setSkuValue(e.target.value)}
            />
            <IFTA
              id="frete-valor"
              text="Valor do material"
              value={insuranceValue}
              onChange={(e) => setInsuranceValue(e.target.value)}
              inputMode="decimal"
            />
            <IFTA
              id="frete-quantidade"
              text="Quantidade"
              value={quantity}
              onChange={(e) => setQuantity(e.target.value)}
              inputMode="numeric"
            />
            <button
              type="submit"
              className="btn btn-primary freight-add"
              disabled={adicionandoProduto}
              aria-busy={adicionandoProduto}
            >
              {adicionandoProduto && <span className="spinner" aria-hidden="true" />}
              {adicionandoProduto ? "Adicionando…" : "Adicionar produto"}
            </button>
          </form>

          {error && (
            <div className="alert alert-error" role="alert">
              <IconAlerta size={18} />
              <span>{error}</span>
            </div>
          )}

          <div className="freight-section">
            <h3 className="section-title">Lista de produtos</h3>
            {temProdutos ? (
              <div className="table-wrapper">
                <table className="data-table">
                  <thead>
                    <tr>
                      <th scope="col">SKU</th>
                      <th scope="col">Quantidade</th>
                      <th scope="col">Dimensões (A × L × C e peso)</th>
                    </tr>
                  </thead>
                  <tbody>
                    {listProducts.map((product, index) => (
                      <tr key={index}>
                        <td>{product.skuValue}</td>
                        <td>{product.quantity}</td>
                        <td>
                          {product.height}cm x {product.length}cm x{" "}
                          {product.width}cm x {product.weight}kg
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <div className="empty-state">
                <IconPacote size={28} />
                <p className="empty-state-title">Nenhum produto adicionado</p>
                <p className="empty-state-text">
                  Busque um produto pelo SKU para começar a cotação.
                </p>
              </div>
            )}
          </div>

          {freightResult && (
            <div className="freight-section">
              <h3 className="section-title">Resultado do frete</h3>
              {freightResult.length > 0 ? (
                <div className="table-wrapper">
                  <table className="data-table">
                    <thead>
                      <tr>
                        <th scope="col">Transportadora</th>
                        <th scope="col">Valor</th>
                        <th scope="col">Valor + 30%</th>
                        <th scope="col">Prazo</th>
                      </tr>
                    </thead>
                    <tbody>
                      {freightResult.map((option, index) => (
                        <tr key={index}>
                          <td>{option.name}</td>
                          <td>R$ {option.price}</td>
                          <td>R$ {(option.price * 1.3).toFixed(2)}</td>
                          <td>{option.delivery_time} dias</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <div className="empty-state">
                  <p className="empty-state-title">
                    Nenhuma opção de frete encontrada
                  </p>
                  <p className="empty-state-text">
                    Confira os CEPs e as dimensões dos produtos.
                  </p>
                </div>
              )}
            </div>
          )}
        </section>
      </div>
    </div>
  );
};

export default Freight;
